export enum EnumServicesTrackingEvents {
  // Service interest button clicked
  SIMPLIS_DECADE_GUARANTEE_INTEREST = 'SIMPLIS_DECADE_GUARANTEE_INTEREST',
  SIMPLIS_PROFESSIONAL_RESPONSABILITY_INTEREST = 'SIMPLIS_PROFESSIONAL_RESPONSABILITY_INTEREST',
  SIMPLIS_PREVOYANCE_INTEREST = 'SIMPLIS_PREVOYANCE_INTEREST',
  SIMPLIS_MULTIRISK_INTEREST = 'SIMPLIS_MULTIRISK_INTEREST',
  SIMPLIS_HEALTHCARE_INTEREST = 'SIMPLIS_HEALTHCARE_INTEREST',
  CASHINTIME_INTEREST = 'CASHINTIME_INTEREST',
  MANSA_INTEREST = 'MANSA_INTEREST',
  CCPM_INTEREST = 'CCPM_INTEREST',
  ZETTLE_INTEREST = 'ZETTLE_INTEREST',
  OTHER_SERVICES_INTEREST = '[Services] Agency Services Interest',
  FINANCING_INTEREST = '[Services] Agency Financing Interest',
  SERVICES_TDAE_INTEREST = 'SERVICES_TDAE_INTEREST',
  RETIREMENT_PLAN_INTEREST = '[Services] Retirement Plan Interest',
  WEBSITE_CREATION_INTEREST = 'WEBSITE_CREATION_INTEREST',
  DIGITAL_VISIBILITY_INTEREST = 'DIGITAL_VISIBILITY_INTEREST',

  // TDAE Urssaf events
  FETCH_TDAE_VERIFY = 'FETCH_TDAE_VERIFY',
  MODAL_TDAE_AUTHORIZATION_REQUEST = 'MODAL_TDAE_AUTHORIZATION_REQUEST',
  MODAL_TDAE_AUTHORIZATION_APPROVED = 'MODAL_TDAE_AUTHORIZATION_APPROVED',
  MODAL_TDAE_CANCEL_MANDATE = 'MODAL_TDAE_CANCEL_MANDATE',
  DELETE_TDAE_MANDATE = 'DELETE_TDAE_MANDATE',
  MODAL_TDAE_TUTORIAL = 'MODAL_TDAE_TUTORIAL',
  TDAE_DECLARATION_FUNNEL = 'TDAE_DECLARATION_FUNNEL',
  FETCH_TDAE_NOT_CATEGORIZED_TRANSACTIONS = 'FETCH_TDAE_NOT_CATEGORIZED_TRANSACTIONS',
  TDAE_DECLARATION_FUNNEL_UNCATEGORIZED_TRANSACTIONS = 'TDAE_DECLARATION_FUNNEL_UNCATEGORIZED_TRANSACTIONS',
  FETCH_TDAE_TURNOVER_ESTIMATE = 'FETCH_TDAE_TURNOVER_ESTIMATE',
  TDAE_DECLARATION_FUNNEL_BLANK_ESTIMATE = 'TDAE_DECLARATION_FUNNEL_BLANK_ESTIMATE',
  TDAE_DECLARATION_FUNNEL_OTHER_ACCOUNT_ESTIMATE = 'TDAE_DECLARATION_FUNNEL_OTHER_ACCOUNT_ESTIMATE',
  TDAE_DECLARATION_FUNNEL_AGGREGATED_ACCOUNT_ESTIMATE = 'TDAE_DECLARATION_FUNNEL_AGGREGATED_ACCOUNT_ESTIMATE',
  TDAE_DECLARATION_FUNNEL_SUMMARY = 'TDAE_DECLARATION_FUNNEL_SUMMARY',
  POST_DECLARE_TDAE = 'POST_DECLARE_TDAE',
  TDAE_DECLARATION_FUNNEL_DECLARED = 'TDAE_DECLARATION_FUNNEL_DECLARED',
  FETCH_TDAE_MANDATES = 'FETCH_TDAE_MANDATES',
  TDAE_DECLARATION_FUNNEL_ADD_RIB = 'TDAE_DECLARATION_FUNNEL_ADD_RIB',
  POST_TDAE_BLANK_IBAN = 'POST_TDAE_BLANK_IBAN',
  POST_TDAE_EXTERNAL_IBAN = 'POST_TDAE_EXTERNAL_IBAN',
  TDAE_DECLARATION_FUNNEL_RIB_SELECTION = 'TDAE_DECLARATION_FUNNEL_RIB_SELECTION',
  TDAE_DECLARATION_FUNNEL_PAYMENT_REQUESTED = 'TDAE_DECLARATION_FUNNEL_PAYMENT_REQUESTED',
  POST_TDAE_PAY = 'POST_TDAE_PAY',
  TDAE_DECLARATION_FUNNEL_PAID = 'TDAE_DECLARATION_FUNNEL_PAID',
  SERVICES_TDAE_LINK_ACCOUNT = 'SERVICES_TDAE_LINK_ACCOUNT',
  TDAE_MODAL_TDAE_WAITING_VIEWED = '[TDAE] Modal TDAE Waiting Viewed',
  TDAE_REDIRECTED_TO_URSSAF_WEBSITE = '[TDAE] Redirected To URSSAF Website',

  // Up2Pay
  UP_TO_PAY_USER_CONSENT = 'UP_TO_PAY_USER_CONSENT',

  ACTIVE_BANNER_CTA_PRESS = 'ACTIVE_BANNER_CTA_PRESS',
}
